import { defineStore } from 'pinia'
import req from '@/api/httpRequest'

export const useUserStateStore = defineStore('userState', () => {
  const stateItems = ref([])
  const currentState = ref({})

  async function fetchStateItems() {
    const { data } = await req.post('dispatcher/state/dict')
    if (data) {
      stateItems.value = data.data
    }
  }

  async function fetchCurrentState() {
    const { data } = await req.get('dispatcher/state/get')
    if (data) {
      currentState.value = stateItems.value.find(
        item => item.id === data.data.state,
      )
    }
  }

  async function changeState(newState) {
    const { name, id } = newState
    const { data } = await req.get(`dispatcher/state/set/${name}`)
    if (data) {
      currentState.value = stateItems.value.find(item => item.id === id)
    }
  }

  return {
    stateItems,
    currentState,
    fetchStateItems,
    fetchCurrentState,
    changeState,
  }
})
